import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GetUserCompany } from '../models/company/get-company';
import { GetAddress } from '../models/security/register-request';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(
    private _http: HttpClient
  ) { }

    public getCompany(CompanyId?: number): Observable<GetUserCompany[]>{
        return this._http.get<GetUserCompany[]>(`${environment.api.url}/Company?CompanyId=${CompanyId??''}`);
    }
    
    public getCompanyById(companyId: string): Observable<GetUserCompany> {
        return this._http.get<GetUserCompany>(`${environment.api.url}/Company/${companyId}`);
    }
    
    public getCompanyAddresses(companyId: string): Observable<GetAddress[]> {
        return this._http.get<GetAddress[]>(`${environment.api.url}/Company/${companyId}/addresses`);
    }
}
